<template>
    <div>
        <app-header :module-navigation="navigation" module-name="Configuration"></app-header>
        <main id="page-main" class="with-tabs">
            <router-view></router-view>
        </main>
    </div>
</template>
<script>
    export default {
        data () {
            return {
                navigation: [
                    {
                        route: 'config',
                        label: 'Dashboard',
                        acl: null
                    },
                    {
                        route: 'attribute',
                        label: 'Attributes',
                        acl: 'weeboxcore.attribute.view'
                    },
                    {
                        route: 'transporter',
                        label: 'Transporteurs colis',
                        acl: 'weeboxcore.transporter.view'
                    },
                    {
                        route: 'payment',
                        label: 'Méthodes de paiements',
                        acl: 'weeboxcore.payment.view'
                    },
                    {
                      route: 'payment-condition',
                      label: 'Conditions de paiement',
                      acl: 'weeboxcore.paymentCondition.view'
                    },
                    {
                      route: 'invoice-template',
                      label: 'Template de facture',
                      acl: 'weeboxcore.invoice-template.view'
                    },
                    {
                        route: 'tax',
                        label: 'Taxes',
                        acl: 'weeboxcore.tax.view'
                    },
                    {
                        route: 'tag',
                        label: 'Tags',
                        acl: 'weeboxcore.tag.view'
                    },
                    {
                        route: 'scope',
                        label: 'Scopes',
                        acl: 'weeboxcore.scope.view'
                    },
                    {
                        route: 'branch',
                        label: 'Succursales',
                        acl: 'weeboxcore.branch.view'
                    },
                    {
                        route: 'calendar',
                        label: 'Calendrier',
                        acl: ['weeboxcore.schedule.view', 'weeboxcore.scopeopeninghour.vue', 'weeboxcore.slotable.vue']
                    },
                    {
                        route: 'acl',
                        label: 'Authorizations',
                        acl: 'is_super_admin'
                    },
                    {
                      route: 'queue',
                      label: 'Logs',
                      acl: 'is_super_admin'
                    }
                ]
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/config/Index.vue